document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 768) return;

  const carousel = document.querySelector('.collection-list');

  if (!carousel) return;

  const items = carousel.querySelectorAll('.collection-list__item');

  if (items.length < 2) return;

  let current = 0;
  let autoplay;

  function goToNext() {
    current++;

    if (current >= items.length) {
      current = 0;
    }

    carousel.scrollTo({
      left: items[current].offsetLeft - carousel.offsetLeft,
      behavior: 'smooth'
    });
  }

  function startAutoplay() {
    clearInterval(autoplay);
    autoplay = setInterval(goToNext, 3500);
  }

  carousel.addEventListener('touchstart', () => {
    clearInterval(autoplay);
  }, { passive: true });

  carousel.addEventListener('touchend', () => {
    startAutoplay();
  }, { passive: true });

  startAutoplay();
});